export const capitalizeFirstLetter = (text: string): string => {
    return text.charAt(0).toUpperCase() + text.slice(1)
}

/** Joins an array of strings by a provided seperator, defaults to " - "
 * @param strings Array of strings
 * @param seperator Seperator used to join the array of strings
 * @example const result = joinStrings(['a', 'b'], ' | ') // = 'a | b'
 */
export const joinStrings = (arrayToJoin: (string | undefined | null)[], seperator: string = ' - '): string => {
    const arrayToJoinFiltered = arrayToJoin.filter((value) => !!value && typeof value === 'string')
    if (!arrayToJoinFiltered.filter.length) return ''

    return arrayToJoinFiltered.join(seperator)
}
